module.exports = __webpack_public_path__ + "img/hyper_extract_knowledge.7ea8a876.jpg";